export default __webpack_public_path__ + "static/media/NomadCampMap.5da8a179.jpg";